import { render, staticRenderFns } from "./VerifyUserRegistration.vue?vue&type=template&id=39a42b84&scoped=true&"
import script from "./VerifyUserRegistration.vue?vue&type=script&lang=js&"
export * from "./VerifyUserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./VerifyUserRegistration.vue?vue&type=style&index=0&id=39a42b84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a42b84",
  null
  
)

export default component.exports